export default "__VITE_ASSET__7af729dd__"